import { createSlice } from '@reduxjs/toolkit'
import createQueryString from 'src/utils/createQueryString'
import axios from 'src/api/index'
import {
  failed,
  success,
} from './snackSlice'
import { startLoading, stopLoading } from './loadingSlice'

export const scholarshipSlice = createSlice({
  name: 'scholarship',
  initialState: { list: [], current: {} },
  reducers: {
    scholarshipsFetched: (state, { payload }) => (
      { ...state, list: payload.data, total: payload.totalHits }
    ),
    scholarshipFetched: (state, { payload }) => ({ ...state, current: payload }),
    scholarshipVotesFetched: (state, { payload }) => ({ ...state, currentVotes: payload }),
  },
})

export default scholarshipSlice.reducer

export const {
  scholarshipsFetched,
  scholarshipFetched,
  scholarshipVotesFetched,
} = scholarshipSlice.actions

export const searchScholarships = (data, callBack) => (dispatch) => {
  dispatch(startLoading())
  axios.get('scholarship', { params: createQueryString(data) })
    .then((res) => {
      dispatch(stopLoading())
      dispatch(scholarshipsFetched(res?.data))
      if (callBack) callBack()
    })
    .catch((e) => {
      dispatch(stopLoading())
      dispatch(failed(e?.response?.data?.message, ''))
      // dispatch(failed(e?.response?.data?.message || 'مشکل در دریافت فهرست بورسیه ها'))
      if (callBack) callBack()
    })
}

export const getScholarships = (data, callBack) => (dispatch) => {
  dispatch(startLoading())
  axios({
    method: 'post',
    url: 'scholarship',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
  })
    .then((res) => {
      dispatch(stopLoading())
      dispatch(scholarshipsFetched(res?.data))
      if (callBack) callBack()
    })
    .catch((e) => {
      dispatch(stopLoading())
      dispatch(failed(e?.response?.data?.message, ''))
      // dispatch(failed(e.response.data.message || 'مشکل در دریافت فهرست بورسیه ها'))
      if (callBack) callBack()
    })
}

export const getScholarship = (scholarshipId, callBack) => (dispatch) => {
  dispatch(startLoading())
  axios({
    method: 'Get',
    url: `scholarship/${scholarshipId}`,
    headers: {
      'Content-Type': ' application/json',
    },
  })
    .then((res) => {
      dispatch(stopLoading())
      dispatch(scholarshipFetched(res?.data.data))
      if (callBack) callBack()
    })
    .catch((e) => {
      dispatch(stopLoading())
      dispatch(failed(e?.response?.data?.message, ''))
      // dispatch(failed(e.response.data.message || 'مشکل در دریافت اطلاعات بورسیه'))
      if (callBack) callBack()
    })
}

export const getScholarshipVotes = (scholarshipId, callBack) => (dispatch) => {
  dispatch(startLoading())
  axios({
    method: 'Get',
    url: `refereeing/${scholarshipId}`,
    headers: {
      'Content-Type': ' application/json',
    },
  })
    .then((res) => {
      dispatch(stopLoading())
      dispatch(scholarshipVotesFetched(res?.data.data))
      if (callBack) callBack()
    })
    .catch((e) => {
      dispatch(stopLoading())
      // dispatch(failed(e?.response?.data?.message, ''))
      dispatch(failed(e?.response?.data?.message || 'مشکل در دریافت رای های داده شده '))
      if (callBack) callBack()
    })
}

export const vote = (data, callBack) => (dispatch) => {
  dispatch(startLoading())
  axios({
    method: 'Post',
    url: 'refereeing',
    headers: {
      'Content-Type': ' application/json',
    },
    data,
  })
    .then((res) => {
      dispatch(stopLoading())
      dispatch(success('با تشکر، رای شما ثبت شد'))
      if (callBack) callBack(res?.data.data)
    })
    .catch((e) => {
      dispatch(stopLoading())
      dispatch(failed(e.response.data.message || 'مشکل در ثبت نظر'))
      if (callBack) callBack()
    })
}

export const approve = (data, callBack) => (dispatch) => {
  dispatch(startLoading())
  axios({
    method: 'Put',
    url: 'scholarship',
    headers: {
      'Content-Type': ' application/json',
    },
    data,
  })
    .then((res) => {
      dispatch(stopLoading())
      dispatch(success('با تشکر، نظر شما اعمال شد'))
      if (callBack) callBack(res?.data.data)
    })
    .catch((e) => {
      dispatch(stopLoading())
      dispatch(failed(e.response.data.message || 'مشکل در ثبت نظر'))
      if (callBack) callBack()
    })
}

export const addScholarship = (data, callBack) => (dispatch) => {
  dispatch(startLoading())
  axios.post('scholarship', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Access-Control-Allow-Origin': '*',
    },
  })
    .then(() => {
      dispatch(stopLoading())
      dispatch(success('درخواست شما با موفقیت ثبت شد'))
      if (callBack && typeof (callBack) === 'function') callBack()
    })
    .catch((e) => {
      dispatch(stopLoading())
      dispatch(failed(e?.response?.data?.message || 'مشکل در ثبت بورس'))
    })
}
